import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ag-fleet-experiences-view',
  templateUrl: './ag-fleet-experiences-view.component.html',
  styleUrls: ['./ag-fleet-experiences-view.component.css', '../../../quote.component.css']
})
export class AgFleetExperiencesViewComponent implements OnInit {
  quote;
  quoteData;
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;

      if (value.fleet_experiences) {
        value.fleet_experiences.forEach((res) => {
          let maxDate = new Date(res.start_date).setFullYear(new Date(res.start_date).getFullYear() + 1);
          res.end_date = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
        });
      }

      this.quoteData = value;
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
